<template>
    <v-sheet>
        <v-badge floating dot class="mb-12 mb-lg-20">
            <h4 class="tit--sm line-height-1">내 보유 포인트</h4>
        </v-badge>

        <v-card flat rounded="lg" color="grey-f1" v-bind="{ loading }">
            <div class="pa-20 pa-md-30 pa-lg-40">
                <v-row align="center">
                    <v-col>
                        <v-layout align-center>
                            <h3 class="tit line-height-1">{{ user?.point?.format?.() || 0 }}P</h3>
                            <v-btn icon text color="grey" v-bind="{ loading }" class="ml-6 ml-lg-10" @click="getPoint">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-col>
                    <v-col cols="auto">
                        <point-form @search="$emit('search')">
                            <template #activator="{ attrs, on }">
                                <v-btn color="primary" v-bind="attrs" v-on="on">충전하기</v-btn>
                            </template>
                        </point-form>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PointForm from "./form/point-form.vue";

export default {
    components: {
        PointForm,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState(["user"]),
    },
    mounted() {
        this.init();
    },

    methods: {
        ...mapActions(["getUser"]),
        async init() {
            this.getPoint();
        },
        async getPoint() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.getUser();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>